+Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.ContentsView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@options = {}, @header) ->
    # just set @options
  render_twitter:->
    @$el.html(@template(@options))
    @sections = []
    for content in @options.contents
      section_options = $.extend({}, @options, { contents: [content] })
      @sections.push(new Monitoring.Reports.Publications.ContentView(section_options, @header))
    first_section = undefined
    if @sections.length >=0
      first_section = @sections.pop()
      first_section.$el.removeClass("delimiter")
      first_section.render_twitter()
      @$('.container').append(first_section.el)      

    for section in @sections
      section.render_twitter()

      @$el.append(section.el)
    @sections.push(first_section)
    return this
    
  render: ->
    @$el.html(@template(@options))
    @sections = []
    for content in @options.contents
      section_options = $.extend({}, @options, { contents: [content] })
      @sections.push(new Monitoring.Reports.Publications.ContentView(section_options, @header))
    first_section = undefined
    if @sections.length >=0
      first_section = @sections.pop()
      first_section.$el.removeClass("delimiter")
      first_section.render()
      @$('.container').append(first_section.el)      

    for section in @sections
      section.render()

      @$el.append(section.el)
    @sections.push(first_section)
    return this

  fill_analytics: (data) ->
    _.each(@sections, (section) -> section.fill_analytics(data))

  fill_twitter_analytics: (data)->
    _.each(@sections, (section) -> section.fill_twitter_analytics(data))    

  fail: ->
    _.each(@sections, (section) -> section.fail())
